<template>
	<svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.55001V35.15H9.25V5.55001H0ZM7.4 27.75H1.85V25.9H7.4V27.75ZM7.4 22.2H1.85V20.35H7.4V22.2ZM11.1 5.55001V35.15H20.35V5.55001H11.1ZM18.5 27.75H12.95V25.9H18.5V27.75ZM18.5 22.2H12.95V20.35H18.5V22.2ZM20.35 6.47501L27.935 34.965L36.815 32.56L29.415 4.25501L20.35 6.47501ZM33.3 26.085L27.935 27.565L27.38 25.715L32.745 24.235L33.3 26.085ZM31.82 20.72L26.455 22.2L26.085 20.35L31.45 18.87L31.82 20.72Z" style="fill: var( --icon-color );"/>
	</svg>

</template>
